module.exports = __webpack_public_path__ + "img/spedometer.e8e9ef3f.svg";